import { put, takeLatest, all, call } from 'redux-saga/effects'
import { getEnergySavingListActionSuccess } from 'src/redux/actions/energySavingAction'
import { ACTION_GET_ENERGY_SAVING_LIST } from 'src/redux/actions/energySavingAction/energySavingActionList'
import instance from 'src/services/api'
import { Endpoint } from '../Endpoint'

function* getEnergySavingList(action) {
  try {
    const configRequest = () => {
      return instance.get(Endpoint.ENERGY_SAVING_LIST, { params: action?.payload })
    }
    const response = yield call(configRequest)
    yield put(getEnergySavingListActionSuccess(response?.data))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getEnergySavingListActionSuccess({
        status: status,
        code: code,
        message: msg,
      }),
    )
  }
}

export default function* getEnergySavingSaga() {
  yield all([takeLatest(ACTION_GET_ENERGY_SAVING_LIST, getEnergySavingList)])
}
